import { signal } from '@preact/signals-react'
import { IndexedDB } from '../../indexDB'

export const chatStore = signal<IndexedDB | null>(null)

export const createChatStore = () => {
    const dbName = 'chatStore'
    const dbVersion = 6
    const dbUpgrade = (db: any) => {
        // create object stores here
        if (!db.objectStoreNames.contains('me')) {
            db.createObjectStore('me')
        }
        if (!db.objectStoreNames.contains('messages')) {
            db.createObjectStore('messages')
        }
        if (!db.objectStoreNames.contains('members')) {
            db.createObjectStore('members')
        }
        if (!db.objectStoreNames.contains('users')) {
            db.createObjectStore('users')
        }
        if (!db.objectStoreNames.contains('channelInfo')) {
            db.createObjectStore('channelInfo')
        }
        if (!db.objectStoreNames.contains('rooms')) {
            db.createObjectStore('rooms')
        }
        if (!db.objectStoreNames.contains('subscriptions')) {
            db.createObjectStore('subscriptions')
        }
    }
    const chatStoreDb = new IndexedDB(dbName, dbVersion, dbUpgrade)
    chatStore.value = chatStoreDb
}

export async function getChatCache<T>(store: string, key: string) {
    try {
        return chatStore.value?.get<T>(store, key)
    } catch {
        return null
    }
}
